import React from 'react';
import TagsRender,{SuggestionsRenderProps} from './TagsRender';

export const Tags=({...props}:SuggestionsRenderProps):JSX.Element=>{
	
	return <TagsRender
		{...props}
	/>;
};
